import { Outlet } from 'react-router-dom'
import { useEffect, useState } from 'react'
import BottomNav from './BottomNav'
import Sidebar from './Sidebar'

const DESKTOP_BREAKPOINT = 900

function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== 'undefined' && window.innerWidth >= DESKTOP_BREAKPOINT
  )

  useEffect(() => {
    const onResize = () => setIsDesktop(window.innerWidth >= DESKTOP_BREAKPOINT)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return isDesktop
}

export default function AppShell() {
  const isDesktop = useIsDesktop()

  if (isDesktop) {
    return (
      <div style={{ display: 'flex', minHeight: '100vh' }}>
        <Sidebar />
        <main style={{ flex: 1, minWidth: 0 }}>
          <Outlet />
        </main>
      </div>
    )
  }

  return (
    <div style={{ minHeight: '100dvh', paddingBottom: 'var(--nav-height-mobile)' }}>
      <main>
        <Outlet />
      </main>
      <BottomNav />
    </div>
  )
}
